const ProcessSection = () => {
  const steps = [
    {
      number: "01",
      title: "Review",
      description: "We assess your current online presence — brokerage pages, directory listings, any existing site — and determine if a standalone website would strengthen your position.",
    },
    {
      number: "02", 
      title: "Build",
      description: "We handle everything — layout, messaging, mobile optimization — so you can stay focused on your clients.",
    },
    {
      number: "03",
      title: "Launch",
      description: "Your site goes live as a professional brand headquarters you can confidently share with prospects, past clients, and referral partners.",
    },
  ];

  return (
    <section className="section-padding bg-section-alt">
      <div className="container-narrow">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4 text-primary">
            A simple process
          </h2>
          <p className="text-soft text-lg">
            No long timelines. No complexity. Just focused execution.
          </p>
        </div>

        {/* Process steps */}
        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="p-8 bg-card rounded-xl border border-border/50 hover:border-border transition-colors duration-300"
            >
              <span className="text-primary font-sans text-sm font-medium tracking-wider mb-4 block">
                {step.number}
              </span>
              <h3 className="text-xl font-semibold mb-3 text-foreground">
                {step.title}
              </h3>
              <p className="text-soft leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
